/* KÔBO — effets de scroll & interactions (fiche produit, collection) — sans dépendance */
(function () {
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desk = function () { return window.innerWidth >= 1000; };

  /* ---------- apparitions ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;
  $$('.k-fx').forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-in'); });

  /* ---------- phrase qui s'allume mot par mot ---------- */
  var hooks = $$('[data-k-words]').map(function (el) {
    var words = el.textContent.trim().split(/\s+/); el.setAttribute('aria-label', el.textContent.trim());
    el.innerHTML = words.map(function (w) { return '<span class="w" aria-hidden="true">' + w + '</span>'; }).join(' ');
    return { el: el, w: $$('.w', el) };
  });

  /* ---------- compteurs ---------- */
  var cio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return; cio.unobserve(e.target);
      var el = e.target, txt = el.textContent, m = txt.match(/(\d+(?:[.,]\d+)?)/); if (!m || reduce) return;
      var target = parseFloat(m[1].replace(',', '.')), dec = (m[1].split(/[.,]/)[1] || '').length, t0 = performance.now(), dur = 1300;
      var run = function (now) { var k = Math.min(1, (now - t0) / dur), v = target * (1 - Math.pow(1 - k, 4)); el.textContent = txt.replace(m[1], v.toFixed(dec).replace('.', m[1].indexOf(',') > -1 ? ',' : '.')); if (k < 1) requestAnimationFrame(run); else el.textContent = txt; };
      requestAnimationFrame(run);
    });
  }, { threshold: 0.6 }) : null;
  $$('[data-k-count]').forEach(function (el) { if (cio && /\d/.test(el.textContent)) cio.observe(el); });

  /* ---------- parallaxe + bandeau réactif au scroll ---------- */
  var para = $$('[data-k-parallax]'), band = $$('[data-k-band] .k-band-track'), lastY = window.scrollY, vel = 0, ticking = false;
  var bandAnim = band.map(function (b) { var a = b.getAnimations && b.getAnimations()[0]; return a; });
  function frame() {
    ticking = false; var vh = window.innerHeight;
    hooks.forEach(function (h) {
      var r = h.el.getBoundingClientRect(), p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (vh * 0.55 + r.height * 0.5))), n = Math.round(p * h.w.length);
      h.w.forEach(function (w, i) { w.classList.toggle('on', i < n); });
    });
    if (!reduce) para.forEach(function (el) {
      var r = el.getBoundingClientRect(); if (r.bottom < -100 || r.top > vh + 100) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh, img = el.querySelector('img'); if (img) img.style.transform = 'translate3d(0,' + (p * -9).toFixed(2) + '%,0) scale(1.15)';
    });
    vel *= 0.9; bandAnim.forEach(function (a) { if (a) a.playbackRate = 1 + Math.min(8, Math.abs(vel) * 0.12) * (vel < 0 ? -0.4 : 1); });
  }
  window.addEventListener('scroll', function () { var y = window.scrollY; vel = y - lastY; lastY = y; if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  frame(); if (!reduce) setInterval(function () { if (Math.abs(vel) > 0.2) frame(); }, 60);

  /* ---------- inclinaison 3D + reflet (galerie, cartes) ---------- */
  if (!reduce && window.matchMedia('(hover: hover)').matches) {
    $$('.k-g-slide, .k-mwrap').forEach(function (el) {
      var host = el.classList.contains('k-mwrap') ? el.querySelector('.im') || el : el;
      el.addEventListener('mousemove', function (e) {
        if (el.classList.contains('k-g-slide') && !desk()) return;
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height, max = el.classList.contains('k-g-slide') ? 5 : 4;
        el.style.transform = 'perspective(1000px) rotateX(' + ((0.5 - y) * max).toFixed(2) + 'deg) rotateY(' + ((x - 0.5) * max * 1.2).toFixed(2) + 'deg) scale(1.012)';
        el.style.setProperty('--gx', (x * 100) + '%'); el.style.setProperty('--gy', (y * 100) + '%'); el.classList.add('is-tilt');
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; el.classList.remove('is-tilt'); });
    });
  }

  /* ---------- curseurs (remplissage) ---------- */
  $$('.k-rng input[type=range]').forEach(function (i) {
    var set = function () { i.style.setProperty('--p', ((i.value - i.min) / (i.max - i.min) * 100) + '%'); };
    i.addEventListener('input', set); set();
  });
})();

/* Fiche produit : garder les deux colonnes remplies au scroll.
   La galerie et le bloc d'achat n'ont jamais la même hauteur, et laquelle est la
   plus courte change selon le produit. On calcule donc le décalage de collage
   colonne par colonne : celle qui tient dans l'écran se fixe sous la nav ; celle
   qui dépasse reçoit un décalage négatif, ce qui la fait défiler en entier avant
   de s'immobiliser — son bas reste atteignable. */
(function () {
  var pdp = document.querySelector('.k-pdp');
  if (!pdp) return;
  var cols = [];
  for (var i = 0; i < pdp.children.length; i++) {
    var c = pdp.children[i];
    if (c.classList.contains('k-g') || c.classList.contains('k-pdp-buy')) cols.push(c);
  }
  if (!cols.length) return;

  var GAP = 28;
  function navH() {
    var v = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--k-nav'), 10);
    return isNaN(v) ? 80 : v;
  }
  function sync() {
    if (window.innerWidth < 1000) {
      cols.forEach(function (c) { c.style.removeProperty('--k-stick'); });
      return;
    }
    var top = navH() + 16;
    cols.forEach(function (c) {
      var h = c.offsetHeight;
      c.style.setProperty('--k-stick', h + top + GAP <= window.innerHeight ? top + 'px' : (window.innerHeight - h - GAP) + 'px');
    });
  }

  sync();
  window.addEventListener('resize', sync);
  window.addEventListener('load', sync);
  // Les accordéons (Description, Spécifications) changent la hauteur de la colonne.
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(sync);
    cols.forEach(function (c) { ro.observe(c); });
  }
})();
